<template>
  <v-dialog
    @click:outside="$emit('close')"
    @keydown.esc="$emit('close')"
    :value="true"
    width="750"
  >
    <!--BARRA AZUL  -->
    <v-toolbar color="primary" dark flat class="dialog-toolbar">
      <v-toolbar-title class="d-flex flex-column justify-center">
        <span class="text-h6" v-text="inscricao.matricula.pessoa.nome" />

        <span
          class="text-caption"
          v-text="
            `Matrícula: ${inscricao.matricula.codigo}  ${' - ' +
              inscricao.matricula.etapa.nome} | ${
              inscricao.matricula.unidadeEnsino.nomeCompleto
            }`
          "
        />
      </v-toolbar-title>
      <!--BARRA AZUL FIM-->
      <v-spacer />

      <v-btn icon @click="$emit('close')">
        <v-icon>
          mdi-close
        </v-icon>
      </v-btn>
    </v-toolbar>

    <v-card color="grey lighten-5">
      <v-card-text>
        <v-col
          cols="12"
          class="text-h6 pt-5 pb-0"
          v-text="`Protocolo: ${inscricao.protocolo}`"
        />

        <v-col
          cols="12"
          class="text-caption pt-0 mb-2"
          v-text="
            `Data da Inscrição: ${format(
              parseISO(inscricao.data_cadastro),
              'dd/MM/yyyy',
            )}`
          "
        />

        <v-col>
          O STATUS DESTA INSCRIÇÃO É
          <strong>{{ getStatus(inscricao.status) }}</strong>
        </v-col>

        <v-col cols="12">
          <CPTFormSubtitle label="Endereço" />
        </v-col>
        <v-col v-if="endereco" cols="12 mb-5 ml-4" class="pa-0 d-flex">
          <v-col
            cols="8"
            v-text="
              `${endereco.logradouro}, ${endereco.bairro}, ${endereco.numero ||
                'S/N'} - ${endereco.cidade.nome}/${
                endereco.cidade.estado.sigla
              }`
            "
            class="pb-0 text-uppercase"
          />
          <v-col
            v-if="endereco.complemento"
            v-text="`Complemento: ${endereco.complemento}`"
            class="pb-0"
          />
        </v-col>

        <v-col cols="12">
          <CPTFormSubtitle label="Documentos" />
        </v-col>

        <v-col cols="12">
          <ListaDocumentos v-if="inscricao" :inscricao="inscricao" />
        </v-col>

        <v-col cols="12" class="pt-2">
          <CPTTextArea
            v-model="inscricao.observacao"
            auto-grow
            label="Observação"
            outlined
            rounded
          />
        </v-col>

        <v-row
          v-if="
            inscricao.status == 'AGUARDANDO_CORRECAO' ||
              inscricao.status == 'PENDENTE'
          "
        >
          <v-col cols="12">
            <CPTFileInput
              v-model="documentos.declaracaoCarteiraTrabalho1"
              accept="image/*,.pdf"
              chips
              counter
              label="Declaração ou Carteira de Trabalho (Responsável 1)"
              multiple
              required
            />
          </v-col>

          <v-col cols="12">
            <CPTFileInput
              v-model="documentos.declaracaoCarteiraTrabalho2"
              accept="image/*,.pdf"
              chips
              counter
              label="Declaração ou Carteira de Trabalho (Responsável 2)"
              multiple
              required
            />
          </v-col>

          <v-col cols="12">
            <CPTFileInput
              v-model="documentos.impossibilidadeFerias1"
              accept="image/*,.pdf"
              chips
              counter
              label="Declaração de impossibilidade de férias (Responsável 1)"
              multiple
              required
            />
          </v-col>

          <v-col cols="12">
            <CPTFileInput
              v-model="documentos.impossibilidadeFerias2"
              accept="image/*,.pdf"
              chips
              counter
              label="Declaração de impossibilidade de férias (Responsável 2)"
              multiple
              required
            />
          </v-col>

          <v-col cols="12">
            <CPTFileInput
              v-model="documentos.cpfCrianca"
              accept="image/*,.pdf"
              chips
              counter
              label="CPF da criança"
              multiple
              required
            />
          </v-col>

          <v-col cols="12">
            <CPTFileInput
              v-model="documentos.comprovanteResidencia"
              accept="image/*,.pdf"
              chips
              counter
              label="Comprovante de Residência"
              multiple
              required
            />
          </v-col>

          <v-col cols="12">
            <v-row justify="end" class="mr-0 mb-5">
              <CPTBtn
                label="Salvar"
                icon="mdi-content-save"
                :disabled="!hasDocumentos"
                :loading="loading"
                @click="onSalvarDocumentos"
              />
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import CPTBtn from "@/components/Btn";
import CPTFileInput from "@/components/FileInput";
import CPTFormSubtitle from "@/components/FormSubtitle";
import CPTTextArea from "@/components/TextArea";
import ListaDocumentos from "../../PLANTAO_DE_FERIAS/consulta-plantao/components/ListaDocumentos";
import { format, parseISO } from "date-fns";
//import { getAtribuicaoAtiva } from "@/plugins/security";

export default {
  name: "dialog-inscricao",

  components: {
    CPTBtn,
    CPTFileInput,
    CPTFormSubtitle,
    CPTTextArea,
    ListaDocumentos,
  },

  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    tipoStatus: {
      type: Array,
      default: () => [],
    },
    unidadesEnsino: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    inscricao: {
      get() {
        return this.value;
      },
      set(inscricao) {
        this.$emit("input", inscricao);
      },
    },

    hasDocumentos() {
      if (!this.documentos || Object.keys(this.documentos).length === 0) {
        return false;
      }

      return Object.values(this.documentos).some(
        (arr) => Array.isArray(arr) && arr.length > 0,
      );
    },
  },

  data() {
    return {
      documentos: {},
      endereco: null,
      loading: false,
    };
  },

  mounted() {
    this.endereco = this.inscricao.matricula.pessoa.endereco;
  },

  methods: {
    format,
    parseISO,

    getStatus(status) {
      return this.tipoStatus.find((item) => item.value === status).label;
    },

    onSalvarDocumentos() {
      const formData = new FormData();
      formData.append("status", "PENDENTE");

      const categoriasDocumentos = {
        declaracao_carteira_trabalho_1: this.documentos
          .declaracaoCarteiraTrabalho1,
        declaracao_carteira_trabalho_2: this.documentos
          .declaracaoCarteiraTrabalho2,
        impossibilidade_ferias1: this.documentos.impossibilidadeFerias1,
        impossibilidade_ferias2: this.documentos.impossibilidadeFerias2,
        cpf_crianca: this.documentos.cpfCrianca,
        comprovante_residencia: this.documentos.comprovanteResidencia,
      };

      // Percorre todas as categorias dinamicamente
      Object.entries(categoriasDocumentos).forEach(([nomeCampo, arquivos]) => {
        (arquivos || []).forEach((arquivo) => {
          formData.append("arquivos", arquivo);
          formData.append("arquivos_nomes", nomeCampo);
        });
      });

      this.$http
        .put(`plantao-ferias/${this.inscricao.id}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((inscricao) => {
          this.showMessage("Inscrição atualizada com sucesso", "success");
          this.$emit("save", inscricao);
        })
        .catch((error) => {
          this.showMessage(error, "error");
        });
    },
  },
};
</script>

<style scoped>
.dialog-toolbar {
  z-index: 1;
  margin: 0;
  top: 0;
  position: sticky;
  padding: 0;
}
</style>
